<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Broadcast List</div>
    <div class="divider"></div>
    <div class="filter">
      <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
    </div>
    <div class="divider"></div>
    <div class="dates">
      <div class="date start-date">
        <div class="text">Start</div>
        <button
          mat-button
          class="icon-btn"
          (click)="startDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #startDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="startDate"
        >
        </lhpe-datepicker>
      </div>
      <div class="date end-date">
        <div class="text">End</div>
        <button
          mat-button
          class="icon-btn"
          (click)="endDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #endDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="endDate"
        >
        </lhpe-datepicker>
      </div>
    </div>

    <div class="divider"></div>
    <div class="search-box input-box">
      <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

      <mat-form-field>
        <input matInput type="text" [formControl]="searchValueControl" />
      </mat-form-field>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right"></div>
</div>

<div class="broadcast-list">
  <div class="container broadcasts-container">
    <div class="container-header no-bottom-border">
      <div class="text">Broadcasts</div>
      <div class="options">
        <button mat-icon-button [matMenuTriggerFor]="broadcastsMenu">
          <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
        </button>
        <mat-menu
          class="mat-menu-elaphant vertical-menu"
          #broadcastsMenu="matMenu"
        >
          <button
            class="icon-btn-w-text"
            mat-menu-item
            (click)="createNewBroadcast()"
          >
            <svg-icon
              src="assets/svg/broadcast-plus.svg"
              svgClass="white"
              [svgStyle]="{ 'width.px': '23.055', 'height.px': '24.99' }"
            ></svg-icon>
            <span>Create New Broadcast</span>
          </button>
        </mat-menu>
      </div>
    </div>
    <div
      class="container-content"
      lhpeElementLoader
      #broadcastElementLoader="elementloader"
    >
      <table
        #broadcastsTable
        mat-table
        [dataSource]="broadcastsDataSource"
        matSort
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let row">
            {{ row.name ? row.name : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.created_at">
              {{ formatDate(row.created_at) }}
            </ng-container>
            <ng-container *ngIf="!row.created_at"> - </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="send_date_time">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Sent</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.send_date_time">
              {{ formatDate(row.send_date_time) }}
            </ng-container>
            <ng-container *ngIf="!row.send_date_time"> - </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="removal_date_time">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Date Removed
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.removal_date_time">
              {{ formatDate(row.removal_date_time) }}
            </ng-container>
            <ng-container *ngIf="!row.removal_date_time"> - </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="audienceName">
          <th mat-header-cell *matHeaderCellDef>Audience</th>
          <td mat-cell *matCellDef="let row">
            {{ row.audience_name ? row.audience_name : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="conversion_length">
          <th mat-header-cell *matHeaderCellDef>Conversions Tracking</th>
          <td mat-cell *matCellDef="let row">
            {{
              conversionTrackingOptions[row.conversion_length]
                ? conversionTrackingOptions[row.conversion_length]
                : "-"
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" class="options-cell">
             
            <button
              *ngIf="row.account_app_audience_id!==null"
              mat-button
              (click)="sendBroadcast(row)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/satellite.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>

            <button
              *ngIf="row.account_app_audience_id!==null"
              mat-button
              (click)="viewAudience(row)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/movies-audience.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>

            <button
              *ngIf="row.scheduled"
              mat-button
              (click)="edit(row)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/pencil.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>

            <button
              *ngIf="!row.scheduled"
              mat-button
              (click)="edit(row)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/view.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>

            <button class="icon-btn" mat-button (click)="delete(row)">
              <svg-icon
                src="assets/svg/trashcan.svg"
                [svgStyle]="{
                  'width.px': '15.25',
                  'height.px': '16.204'
                }"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <!-- <div
                *ngIf="!(row.id !== currentUser.id && showDelete)"
                class="empty-btn-space"
              ></div> -->
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="perPage" (page)="onPageChange($event)"></mat-paginator>
    </div>
  </div>
</div>
